import request from '@/plugin/axios'

/**
 * 查询空调列表
 * @param params
 * @returns {*}
 */
export function queryAcFeeDetailsAllByLimit (params) {
  return request({
    url: '/v1/electricity/acFeeDetails/queryAcFeeDetailsAllByLimit',
    method: 'get',
    params
  })
}

/**
 * 单户结算
 * @param data
 * @returns {*}
 */
export function airConditioningElectricityApportionment (data) {
  return request({
    url: '/v1/electricity/acFeeDetails/airConditioningElectricityApportionment',
    method: 'post',
    data
  })
}

/**
 * 批量结算
 * @param data
 * @returns {*}
 */
export function electricityApportionmentAccordingToConditions (data) {
  return request({
    url: '/v1/electricity/acFeeDetails/electricityApportionmentAccordingToConditions',
    method: 'post',
    data
  })
}

/**
 * 批量结算
 * @param data
 * @returns {*}
 */
export function batchSettlementIsVoid (data) {
  return request({
    url: '/v1/electricity/acFeeDetails/batchSettlementIsVoid',
    method: 'post',
    data
  })
}

